<template>
  <div style="overflow-x: hidden">
    <Loading v-if="isLoading" />
    <Popup :message="$t('prakerja.popup.message')" :isError="false" v-if="isPopup" @close="() => (isPopup = false)" />
    <Modal v-if="isModal" @close="() => (isModal = false)" width="95%">
      <div style="text-align: center">
        <h2>{{ $t('prakerja.modal.title') }}</h2>
        <p class="voucher-desc">
          {{ $t('prakerja.modal.description') }}
        </p>
        <div class="input-box">
          <p>{{ $t('prakerja.modal.inputVoucher') }}</p>
          <v-text-field :disabled="confirmVoucher" outlined v-model="codeVoucher" class="form-input"
            placeholder="Enter Voucher Code" dense clearable></v-text-field>
          <p>{{ $t('prakerja.modal.inputRedeem') }}</p>
          <v-text-field :disabled="confirmVoucher" outlined v-model="codeRedeem" class="form-input"
            placeholder="Enter Redeem Code" dense clearable></v-text-field>
        </div>
        <div class="alert-notif" v-if="isError == true || isError == false">
          <span style="color: #b80f0a" v-if="isError == true">{{ $t('prakerja.modal.alertInvalid') }}</span>
          <span style="color: #01a368" v-if="isError == false">{{ $t('prakerja.modal.alertValid') }}</span>
        </div>
        <div class="button-confirm">
          <Button :name="$t('prakerja.modal.button')" :disabled="!codeVoucher || !codeRedeem || confirmVoucher"
            height="45px" width="100%" @click="onCheckVaidVoucher" />
        </div>
      </div>
    </Modal>
    <div class="banner">
      <h2 class="title-banner">{{ $t('prakerja.banner.title') }}</h2>
      <p class="sub-title-banner" v-html="$t('prakerja.banner.subtitle')"></p>
    </div>
    <div class="bg-white-radius" style="margin-bottom: 20px">
      <!-- <ExchangeVoucher style="margin-bottom:80px;"/> -->
    </div>
    <div class="container text-center" style="
        margin-top: -50px;
        background: linear-gradient(
          180deg,
          rgba(241, 246, 255, 0) 0%,
          #f1f6ff 100%
        );
        height: 700px;
        position: relative;
      ">
      <!-- <div class="voucher-box">
        <p class="voucher-box-desc">
          Sudah beli kelas Prakerja di Mitra Digital Platform HiColleagues?
        </p>
        <div
          class="d-flex bg-yellow justify-center"
          @click="openModalTukarVoucher"
        >
          <img src="/img/other/ic_ticket.png" width="28" height="22" />
          <span class="exhange-voucher">TUKAR KODE VOUCHER</span>
        </div>
      </div> -->
      <h3 class="sub-title-span">{{ $t('prakerja.container.title') }}</h3>
      <span class="font-poppins" style="font-size: 13px">{{ $t('prakerja.container.subtitle') }}</span>
      <div class="scrolling-wrapper">
        <div v-for="n in listOfPrakerja" :key="n.id" class="mt-5 card">
          <v-card class="black--text prakerja-card mr-5" style="height: 360px">
            <div @click="goToClassDetail(n.slug_name, n.name)">
              <img :src="n.image_url" width="310px" height="200px" style="
                  border-top-left-radius: 20px;
                  border-top-right-radius: 20px;
                " />
            </div>
            <div class="class-name" style="text-align: left; height: 80px; margin-top: 14px">
              <p @click="goToClassDetail(n.slug_name, n.name)">
                {{ n.name }}
              </p>
              <Button :name="$t('prakerja.a1')" bold @click="() => toCheckout(n)" width="100%" />
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <div class="blue-section text-justify">
      <h1 class="text-center" style="font-size: 20px">
        {{ $t('prakerja.requirements.title') }}
      </h1>
      <img src="/img/prakerja/Prakerja.png" alt="Prakerja Banner" class="mt-4"
        style="border-radius: 14px; width: 100%" />
      <div class="prakerja-ctn">
        <p>{{ $t('prakerja.aboutPrakerja.descriptionLeft.0') }}</p>
        <p>{{ $t('prakerja.aboutPrakerja.descriptionRight.0') }}</p>
        <h4 style="font-size: 20px; margin-top: 30px">
          {{ $t('prakerja.requirements.title') }}
        </h4>
      </div>
      <div v-for="(item, idx) in $t('prakerja.requirementsPrakerjaProgram')" :key="idx"
        style="display: flex; margin-top: 6px; gap: 5px">
        <img src="/img/icons/check.png" style="width: 25px; height: 25px" alt="Check" />
        <p v-html="item" style="font-size: 16px"></p>
      </div>
      <h1 class="sub-title-span mt-5" style="text-align: left">
        {{ $t('prakerja.requirements.desc') }}
      </h1>
      <div class="roadmap-line">
        <img src="/img/prakerja/line-vertikal.png" alt="line prakerja" />
        <div class="raoadmap-content">
          <div class="roadmap-info" v-for="(item, idx) in $t('prakerja.roadmap')" :key="idx">
            <div class="rounded-blue-out">
              <div class="rounded-blue">
                <span>{{ idx + 1 }}</span>
              </div>
            </div>
            <div style="text-align: left">
              <h6 style="font-size: 16px">
                {{ item.title }}
              </h6>
              <span class="font-poppins" style="margin-top: 6px; font-size: 14px">{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-blue button-other" @click="goToPrakerja">
        <span class="font-poppins">{{ $t('kampusMerdeka.a1') }}</span>
        <Arrow direct="left" />
      </div>
    </div>

    <div class="container" style="margin: 50px auto">
      <h2 class="sub-title-span text-center">
        {{ $t('prakerja.a2') }}
      </h2>
      <div v-for="n in $t('prakerja.benefits')" :key="n.id" class="content-card mr-2 ml-2">
        <div class="left-span">
          <img :src="n.image" width="70" height="70" style="border-radius: 50%" />
        </div>
        <div>
          <h3 class="title-2">{{ n.title }}</h3>
          <p class="desc mt-2">{{ n.desc }}</p>
        </div>
      </div>
    </div>
    <h3 class="sub-title-span text-center">{{ $t('kampusMerdeka.a4') }}</h3>
    <Alumni style="padding: 0 12px" />
    <div class="faqbg mt-10">
      <div class="faq">
        <h1>Frequently Asked Question</h1>
        <div class="container">
          <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
            :description="item.description" :active="item.active" @toggle="toggleAccordion(index)" />
          <div class="btn-stoke-blue cursor-pointer mt-5" @click="goToFaqPage">
            <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
            <ArrowLong />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/others/Popup.vue";
import Modal from "@/components/others/Modal.vue";
import Button from "@/components/others/Button.vue";
import Alumni from "@/components/prakerja/Alumni";
import Arrow from "@/assets/icons/Arrow.vue";
import Loading from "../../ilustration/Loading.vue";
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  components: {
    Alumni,
    Modal,
    Popup,
    Button,
    Loading,
    ArrowLong,
    AccordeonFaq,
    Arrow
  },
  data() {
    return {
      roadmap: [
        {
          title: "Pendaftaran Kartu Prakerja",
          desc: "Lakukan pendaftaran peserta melalui Website Kartu Prakerja.",
          id: 1,
        },
        {
          title: "Seleksi Kartu Prakerja",
          desc: "Ikuti Tes Motivasi & Kemampuan Dasar untuk mendapatkan Unique ID Kartu Prakerja per Batch-nya.",
          id: 2,
        },
        {
          title: "Pilih Lembaga Pelatihan HiColleagues",
          desc: "Jelajahi Kelas Prakerja di website HiColleagues. Atau beli Kelas Prakerja yang kamu minati di Mitra Kartu Prakerja HiColleagues dan dapatkan Kode Voucher kelas di setiap pembeliannya.",
          id: 3,
        },
        {
          title: "Tukar Kode Voucher",
          desc: "Tukarkan Kode Voucher di HiColleagues. Dapatkan Email Konfirmasi untuk Login dalam LMS dan ikuti Kelas Pelatihan Webinar via Zoom.",
          id: 4,
        },
        {
          title: "Ikuti Pelatihan",
          desc: "Ikuti dan selesaikan Kelas Pelatihan untuk mendapatkan sertifikat sebagai bukti bahwa kamu telah menyelesaikan kelas yang kamu minati dengan baik.",
          id: 5,
        },
        {
          title: "Berikan Ulasan & Rating",
          desc: "Berikan Ulasan & Rating pada Kelas Pelatihan yang telah diikuti di form HiColleagues & platform Mitra Kartu Prakerja.",
          id: 6,
        },
        {
          title: "Isi Survey & Dapatkan Insentif",
          desc: "Isi survey yang tersedia di dashboard Kartu Prakerja dan dapatkan insentif dari pemerintah.",
          id: 7,
        },
      ],
      whyHicolleagues: [
        {
          image: "/img/prakerja/ic_mentor_berpengalaman.png",
          title: "Instruktur Berpengalaman",
          desc: "Pelatihan akan dibimbing oleh instruktur yang berpengalaman di bidangnya.",
        },
        {
          image: "/img/prakerja/ic_lms.png",
          title: "Menggunakan LMS",
          desc: "LMS (Learning Management System) upaya mendukung kegiatan Kelas Prakerja berjalan optimal.",
        },
        {
          image: "/img/prakerja/ic_materi_relevan.png",
          title: "Materi Relevan",
          desc: "Materi yang dipelajari dibutuhkan industri saat ini & potensial untuk masa depan.",
        },
      ],
      partnerships: [
        {
          image: "/img/partner/tokopedia.png",
          link: "https://www.tokopedia.com/kartu-prakerja/partner/hicolleagues",
        },
        {
          image: "/img/partner/bukalapak.png",
          link: "https://www.bukalapak.com/kartu-prakerja/pencarian?source=dope&source=navbar&from=omnisearch&from_keyword_history=false&search_source=omnisearch_virtual_products&keyword=hicolleagues",
        },
        {
          image: "/img/partner/pintaria.png",
          link: "https://pintar.co/kartuprakerja/HiColleagues",
        },
        {
          image: "/img/partner/kariermu.png",
          link: "https://www.karier.mu/program?search=hicolleagues",
        },
        {
          image: "/img/partner/pijar.png",
          link: "https://pijarmahir.id/category/kartu-prakerja?lp=776291",
        },
      ],
      requrementsPrakerjaProgram: [
        "WNI berusia paling rendah 18 tahun dan paling tinggi 64 tahun",
        "Tidak sedang menempuh pendidikan formal",
        "Sedang mencari kerja, pekerja/buruh yang terkena PHK, atau pekerja/buruh yang membutuhkan peningkatan kompetensi kerja, seperti pekerja/buruh yang dirumahkan dan pekerja",
        "bukan penerima upah, termasuk pelaku usaha mikro & kecil. <br/> Bukan Pejabat Negara, Pimpinan dan Anggota DPRD, Aparatur",
        "Sipil Negara, Prajurit TNI, Anggota Polri, Kepala Desa dan perangkat desa dan Direksi/Komisaris/Dewan Pengawas pada BUMN atau BUMD<br>Maksimal 2 NIK dalam 1 KK yang menjadi Penerima Kartu Prakerja",
      ],
      benefits: [
        {
          image: "/img/event/narasumber-profesional.png",
          title: "Instruktur Berpengalaman",
          desc: "Pelatihan akan dibimbing oleh instruktur yang berpengalaman di bidangnya",
        },
        {
          image: "/img/prakerja/ic_sertifikat_completion.png",
          title: "Learning Management System",
          desc: "Mendukung penuh kegiatan Kelas Kartu Prakerja berjalan optimal melalui fitur LMS",
        },
        {
          image: "/img/prakerja/ic_focus.png",
          title: "Materi Relevan & Mudah Dipahami",
          desc: "Materi pelatihan sesuai perkembangan industri saat ini & penyampaian mudah diterima peserta",
        },
        {
          image: "/img/prakerja/ic_sertifikat_kompetensi.png",
          title: "Penerbitan Sertifikat Aktual",
          desc: "Jaminan penerbitan Sertifikat Kartu Prakerja dilakukan setelah seluruh rangkaian mekanisme selesai",
        },
        {
          image: "/img/prakerja/ic_cs.png",
          title: "CS Responsif",
          desc: "Tim yang selalu siap melayani & merespon kebutuhan peserta",
        },
      ],
      questions: [],
      listOfPrakerja: [],
      isModal: false,
      isPopup: false,
      isError: null,
      isLoading: false,
      confirmVoucher: false,
      codeVoucher: "",
      codeRedeem: "",
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
    };
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getFaq();
      this.listOfPrakerja = [];
      this.getClass();
    },
  },
  methods: {
    toggleAccordion(index) {
      this.questions[index].active = !this.questions[index].active;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.questions[index].title} - Prakerja Mobile Page`,
        value: 1,
      });
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=EVENT&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.error(err);
      }
    },
    async getClass() {
      this.isLoading = true;
      try {
        const response = await this.$http.get(`/v1/class/category/4`);
        response.data.data.classes.forEach((element) => {
          this.listOfPrakerja.push({
            id: parseInt(element.id),
            name: element.name,
            image_url: element.thumbnail_url,
            description: element.description,
            level: element.level,
            slug_name: element.slug_name,
            instructor: element.instructor,
          });
        });
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.error(err);
      }
    },
    async onCheckVaidVoucher() {
      this.isError = null;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Check Voucher - Prakerja Mobile Page`,
        value: 1,
      });
      try {
        await this.$http.post(
          `/v1/voucher-prakerja?redeem_code=${this.codeRedeem}&voucher_code=${this.codeVoucher}`
        );
        sessionStorage.setItem("voucher_code", this.codeRedeem);
        sessionStorage.setItem("redeem_code", this.codeRedeem);
        this.confirmVoucher = true;
        this.isError = false;
        this.$gtag.event('success', {
          event_category: 'Interaction',
          event_label: `Voucher Validated - Prakerja Mobile Page`,
          value: 1,
        });
      } catch {
        this.isError = true;
        this.$gtag.event('error', {
          event_category: 'Interaction',
          event_label: `Invalid Voucher - Prakerja Mobile Page`,
          value: 1,
        });
      }
    },
    async toCheckout(data) {
      this.isLoading = true;
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Checkout - ${data.name} - Prakerja Mobile Page`,
        value: 1,
      });
      try {
        const response = await this.$http.get(`/v1/class-detail/${data.slug_name}`);
        const classDetail = response.data.data.class_detail;
        const reqCheckout = JSON.stringify({
          class_id: classDetail.class_id,
          class_name: classDetail.name,
          price: classDetail.price,
          level: classDetail.level,
          session: classDetail.session_total,
          hour: classDetail.hours,
          image_url: classDetail.small_image_url,
          class_type: "PRAKERJA_CLASS",
          days: classDetail.days,
          methode: classDetail.method,
          category_id: classDetail.category_id,
        });

        localStorage.clear();
        localStorage.setItem("checkout", reqCheckout);
        this.isLoading = false;
        window.location.href = "/checkout";
      } catch (err) {
        console.error(err);
        this.isLoading = false;
      }
    },
    openModalTukarVoucher() {
      if (this.confirmVoucher) {
        this.isPopup = true;
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: `Voucher Already Confirmed Popup - Prakerja Mobile Page`,
          value: 1,
        });
        return;
      }
      this.isModal = true;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Open Voucher Modal - Prakerja Mobile Page`,
        value: 1,
      });
    },
    goToPrakerja() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Visit Prakerja Website - Prakerja Mobile Page`,
        value: 1,
      });
      window.open("https://www.prakerja.go.id/tentang-prakerja", "_blank");
    },
    goTo(e) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Visit Partner - ${e} - Prakerja Mobile Page`,
        value: 1,
      });
      window.open(e, "_blank");
    },
    handleView() {
      if (
        sessionStorage.getItem("voucher_code") &&
        sessionStorage.getItem("redeem_code")
      ) {
        this.confirmVoucher = true;
        this.isError = false;
        this.codeVoucher = sessionStorage.getItem("voucher_code");
        this.codeRedeem = sessionStorage.getItem("redeem_code");
      }
    },
    goToFaqPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View More FAQs - Prakerja Mobile Page`,
        value: 1,
      });
      this.$router.push('/faq');
    },
    goToClassDetail(slugName, className) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Class Detail - ${className} - Prakerja Mobile Page`,
        value: 1,
      });
      this.$router.push(`/class/prakerja/${slugName}?tipe_kelas=prakerja`);
    },
  },
  mounted() {
    this.handleView();
    this.getClass();
    this.getFaq();
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style src="./prakerja.css" scoped></style>